// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/resizer/resizer.component.scss
// module id = 221
// module chunks = 0